/* eslint-disable no-param-reassign */
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from 'Helpers/date-utils';
import { Popup, Placeholder, Menu } from 'semantic-ui-react';
import { useHistory } from 'react-router';
// import { getToken } from 'firebase/messaging';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNotifications,
  getBadges,
  readNotification,
  readAllNotifications,
} from 'Redux/modules/notification/actions';
import { Waypoint } from 'react-waypoint';
import { APPOINTMENT, LAB_REPORT, NEWS_FEED } from 'Constants/service-types';
import { DEFAULT_GET_NOTI_PARAMS, NotificationStatus } from 'Containers/Notification/constants';
import { bool, func } from 'prop-types';
import NotiServiceIcon from 'Containers/Notification/NotiServiceIcon';
import { addModal } from 'Redux/modules/modal/actions';

import style from './NotificationList.less';

const NotificationList = ({ isPopup = false, onClickItem }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [params, setParams] = useState(DEFAULT_GET_NOTI_PARAMS);
  const [open, setOpen] = useState(false);
  const { listNoti, status, moreNoti } = useSelector(state => state.notification);
  const handleWaypointEnter = () => {
    setParams({
      ...params,
      offset: params.offset + 30,
    });
  };

  const handleClickNoti = noti => {
    onClickItem?.(noti);

    if (noti.service === APPOINTMENT) {
      history.push('/appointments');
    }
    if (noti.service === LAB_REPORT) {
      history.push(`/lab-results/${(noti.deeplink || '').split('lab-results/')[1]}`);
    }
    if (noti.status !== NotificationStatus.READ) {
      dispatch(readNotification(noti.id));
    }

    const prescriptionId = noti?.data?.prescriptionId;
    if (prescriptionId) {
      dispatch(
        addModal({
          type: 'prescription',
          id: 2,
          data: {
            prescriptionId,
          },
        }),
      );
    }
  };

  const handleReadAllNoti = async () => {
    await dispatch(readAllNotifications());
    await dispatch(getBadges());
    setParams(DEFAULT_GET_NOTI_PARAMS);
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getNotifications(params));
  }, [dispatch, params]);

  return (
    <div className={isPopup ? style.containerPopup : style.container}>
      <div className={style.header}>
        <div className={style.title}>
          <h3 style={{ marginBottom: '0' }} />
          {isPopup && (
            <Link style={{ fontSize: '12px' }} to="/notification">
              View all
            </Link>
          )}
        </div>
        <Popup
          className={style.noPaddingPopup}
          eventsEnabled={false}
          content={
            <Menu
              vertical
              className="prevent-close-popup"
              style={{ boxShadow: 'none', border: 'none' }}>
              <Menu.Item
                className="prevent-close-popup"
                style={{ border: 'none' }}
                name="mark"
                onClick={handleReadAllNoti}>
                Mark all as read
              </Menu.Item>
            </Menu>
          }
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          position="bottom right"
          size="mini"
          on="click"
          trigger={
            <img
              alt="setting"
              style={{ paddingRight: '12px', cursor: 'pointer' }}
              src={require('Assets/images/commons/setting_thin.svg')}
            />
          }
        />
      </div>
      <div
        className={classNames({
          [style.wrapListNotifPopup]: isPopup,
          [style.wrapListNotif]: !isPopup,
        })}>
        {listNoti?.map(e => (
          <div
            key={e.id}
            className={classNames([style.item], {
              [style.itemActive]: e.status !== NotificationStatus.READ,
            })}
            onClick={() => handleClickNoti(e)}>
            <div className={style.icon}>
              <img
                src={e.icon}
                onError={ele => {
                  if (e.service === NEWS_FEED) {
                    ele.currentTarget.src = require('Assets/images/broadcast.png');
                  } else {
                    ele.currentTarget.src = require('Assets/images/pages/web-chat/avatar-default.png');
                  }
                }}
                alt="notif title"
                style={{ borderRadius: e.service === NEWS_FEED ? '8px' : '50%' }}
              />
              <NotiServiceIcon type={e.service} />
            </div>
            <div className={style.content}>
              <div className={style.text}>{e.body}</div>
              <div className={style.time}>{formatDate(e.createdAt, 'DD/MM/YYYY hh:mm A')}</div>
            </div>
          </div>
        ))}

        {listNoti.length <= 0 && status.listNoti === 1 && (
          <div className={style.wrapEmpty}>
            <img alt="empty-noti" src={require('Assets/images/empty_notif.png')} />
            <div>No notification yet</div>
          </div>
        )}

        {(moreNoti.length > 0 || status.listNoti !== 1) && (
          <Waypoint onEnter={handleWaypointEnter}>
            <div style={{ padding: '24px' }} className="text-center">
              <Placeholder>
                <Placeholder.Header image>
                  <Placeholder.Line />
                  <Placeholder.Line />
                </Placeholder.Header>
              </Placeholder>
            </div>
          </Waypoint>
        )}
      </div>
    </div>
  );
};

NotificationList.propTypes = {
  isPopup: bool,
  onClickItem: func,
};

export default NotificationList;
